<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="login otp d-flex flex-column flex-lg-row flex-column-fluid bg-white"
      :class="{
        'login-request-on': this.state === 'request',
        'login-submit-on': this.state === 'submit'
      }"
      id="kt_login"
    >
      <!--begin::Aside-->
      <div class="login-aside d-flex flex-column flex-row-auto bg-gray-100">
        <div class="d-flex flex-column-auto flex-column pt-lg-40 pt-15">
          <a href="#" class="text-center mb-10">
            <img src="/media/logos/logo.png" class="max-h-70px" alt="mirol" />
          </a>
          <h3
            class="font-weight-bolder text-center font-size-h4 font-size-h1-lg text-primary"
          >
            سرویس پخش زنده همزمان
          </h3>
        </div>
        <div
          class="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-y-bottom bgi-position-x-center bgi-size-contain"
          :style="{ backgroundImage: `url(${backgroundImage})` }"
        ></div>
      </div>
      <!--begin::Aside-->
      <!--begin::Content-->
      <div
        class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto"
      >
        <div class="d-flex flex-column-fluid flex-center">
          <!--begin::Request-->
          <div class="login-form login-request">
            <form
              class="form"
              novalidate="novalidate"
              id="kt_login_request_form"
            >
              <div class="pb-13 pt-lg-0 pt-5">
                <h3
                  class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg"
                >
                  ورود کاربران
                </h3>
              </div>
              <div class="form-group">
                <label class="font-size-h6 font-weight-bolder text-dark">
                  شماره همراه
                </label>
                <the-mask
                  mask="09## ### ## ##"
                  v-model="form.cellphone"
                  :masked="true"
                  name="cellphone"
                  ref="cellphone"
                  placeholder="09__ ___ __ __"
                  class="form-control form-control-solid form-control-lg mb-2 text-center"
                  dir="ltr"
                  autocomplete="off"
                ></the-mask>
              </div>
              <vue-hcaptcha
                v-if="hCaptcha.render"
                :sitekey="hCaptcha.siteKey"
                language="fa"
                @verify="onVerify"
                @expired="onExpire"
                @challengeExpired="onExpire"
                @error="onError"
              ></vue-hcaptcha>
              <div class="pb-lg-0 pb-5">
                <button
                  ref="send_code_submit"
                  class="btn btn-primary font-weight-bolder font-size-h6 px-15 py-4 my-3 mr-3"
                  :disabled="isDisabled"
                >
                  ارسال کد
                </button>
                <router-link
                  :to="{ name: 'login', query: $route.query }"
                  class="btn btn-light-primary font-weight-bolder px-8 py-4 my-3 font-size-lg"
                >
                  <span class="svg-icon svg-icon-md">
                    <inline-svg src="/media/svg/icons/General/Unlock.svg" />
                  </span>
                  ورود با گذرواژه
                </router-link>
              </div>
            </form>

            <div class="mt-5">
              با ثبت‌نام در میرول
              <a
                href="https://mirol.ir/terms"
                class="text-primary text-hover-info"
              >
                قوانین و مقررات
              </a>
              آن را می‍پذیرم.
            </div>
          </div>
          <!--end::Request-->
          <!--begin::Submit-->
          <div class="login-form login-submit">
            <form
              class="form"
              novalidate="novalidate"
              id="kt_login_submit_form"
            >
              <div class="pb-13 pt-lg-0 pt-5">
                <p class="text-muted font-weight-bold font-size-h6">
                  کد تایید شماره همراه برای شما پیامک شد. لطفا آنرا وارد کنید.
                </p>
              </div>
              <div class="form-group">
                <the-mask
                  mask="######"
                  v-model="form.otp"
                  :masked="true"
                  name="otp"
                  ref="otp"
                  placeholder="______"
                  class="form-control form-control-solid form-control-lg mb-2 text-center"
                  dir="ltr"
                  autocomplete="off"
                ></the-mask>
              </div>
              <div class="text-right">
                <div class="timer">{{ prettyTime(time) }}</div>
              </div>

              <div class="form-group d-flex flex-wrap pb-lg-0 pb-3">
                <button
                  ref="kt_login_submit_submit"
                  class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-4"
                  style="width: 150px"
                >
                  ارسال
                </button>
                <button
                  type="button"
                  id="kt_login_submit_cancel"
                  class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-4 my-3"
                  @click="stopTimer"
                >
                  بازگشت
                </button>
              </div>
            </form>
          </div>
          <!--end::Submit-->
        </div>
        <!--begin::Content footer-->
        <div
          class="d-flex justify-content-lg-start justify-content-center align-items-end py-7 py-lg-0"
        >
          <a
            href="https://mirol.ir/"
            class="text-primary font-weight-bolder font-size-h5"
          >
            خانه
          </a>
          <a
            href="https://mirol.ir/docs"
            class="text-primary ml-10 font-weight-bolder font-size-h5"
          >
            راهنما
          </a>
          <a
            href="https://mirol.ir/terms"
            class="text-primary ml-10 font-weight-bolder font-size-h5"
          >
            شرایط استفاده
          </a>
          <a
            href="https://mirol.ir/privacy"
            class="text-primary ml-10 font-weight-bolder font-size-h5"
          >
            حریم خصوصی
          </a>
        </div>
        <!--end::Content footer-->
      </div>
      <!--end::Content-->
    </div>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/otp.scss";
</style>

<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import VueHcaptcha from "@hcaptcha/vue-hcaptcha";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";
import KTUtil from "@/assets/js/components/util";
import { mapState } from "vuex";
import { OTP_REQUEST, OTP_SUBMIT } from "@/core/services/store/auth.module";
import { INIT_INFO, VERIFY_USER } from "@/core/services/store/profile.module";
import { TheMask } from "vue-the-mask";
import JwtService from "@/core/services/jwt.service";

export default {
  name: "otp",
  data() {
    return {
      state: "check",
      off: "off",
      time: 0,
      timer: null,
      form: {
        cellphone: "",
        otp: ""
      },
      hCaptcha: {
        siteKey: process.env.VUE_APP_HCAPTCHA_SITE_KEY,
        render: true,
        verified: false,
        expired: false,
        token: null,
        eKey: null,
        error: null
      }
    };
  },
  components: {
    TheMask,
    VueHcaptcha
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    backgroundImage() {
      return process.env.BASE_URL + "media/login.png";
    },
    isDisabled() {
      return this.hCaptcha.verified !== true;
    }
  },
  mounted() {
    this.checkIsAuthenticated();
    this.saveAdsToken();

    const request_form = document.getElementById("kt_login_request_form");
    const submit_form = document.getElementById("kt_login_submit_form");

    this.fv = formValidation(request_form, {
      fields: {
        cellphone: {
          validators: {
            notEmpty: {
              message: "شماره همراه خود را وارد کنید"
            },
            stringLength: {
              min: 14,
              message: "شماره همراه صحیح نیست"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap()
      }
    });

    this.fv1 = formValidation(submit_form, {
      fields: {
        otp: {
          validators: {
            notEmpty: {
              message: "کد را وارد کنید"
            },
            regexp: {
              regexp: /[0-9]|[\u06F0-\u06F9]|[\u0660-\u0669]*/i,
              message: "کد صحیح نیست"
            },
            stringLength: {
              min: 6,
              message: "کد صحیح نیست"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap()
      }
    });

    this.fv.on("core.form.valid", () => {
      let cellphone = this.parsePhone(this.form.cellphone);
      let captcha = this.hCaptcha.token;

      // set spinner to submit button
      const submitButton = this.$refs["send_code_submit"];
      this.disableBtn(submitButton);
      this.hCaptcha.render = false;

      // send login request
      this.$store
        .dispatch(OTP_REQUEST, { cellphone, captcha })
        .then(response => {
          this.time = response["expires_after"];
          this.startTimer();
          this.showForm("submit");

          this.hCaptcha.render = true;
          this.enableBtn(submitButton);
        })
        .catch(() => {
          this.hCaptcha.render = true;
          this.enableBtn(submitButton);
        });
    });

    this.fv.on("core.form.invalid", () => {
      this.showError("لطفا شماره همراه را به طور صحیح وارد نمایید");
    });

    this.fv1.on("core.form.valid", () => {
      let cellphone = this.parsePhone(this.form.cellphone);
      let otp = this.parseNumbers(this.form.otp);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_submit_submit"];
      this.disableBtn(submitButton);

      this.$store
        .dispatch(OTP_SUBMIT, {
          cellphone: cellphone,
          otp: otp
        })
        .then(response => {
          this.$store.dispatch(INIT_INFO, response.user);
          this.redirect();
        })
        .catch(() => {
          this.enableBtn(submitButton);
        });
    });

    this.fv1.on("core.form.invalid", () => {
      this.showError("لطفا کد را به طور صحیح وارد نمایید");
    });
  },
  methods: {
    showForm(form) {
      this.state = form;
      let form_name = "kt_login_" + form + "_form";
      KTUtil.animateClass(
        KTUtil.getById(form_name),
        "animate__animated animate__backInUp"
      );
    },
    startTimer() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.time > 0) {
            this.time--;
          } else {
            this.stopTimer();
          }
        }, 1000);
      }
    },
    stopTimer() {
      clearInterval(this.timer);
      this.timer = null;
      this.time = 0;
      this.showForm("request");
    },
    onVerify(token, eKey) {
      this.hCaptcha.verified = true;
      this.hCaptcha.token = token;
      this.hCaptcha.eKey = eKey;
    },
    onExpire() {
      this.hCaptcha.verified = false;
      this.hCaptcha.token = null;
      this.hCaptcha.eKey = null;
      this.hCaptcha.expired = true;
    },
    onError(err) {
      this.hCaptcha.token = null;
      this.hCaptcha.eKey = null;
      this.hCaptcha.error = err;
    },
    checkIsAuthenticated() {
      this.$store
        .dispatch(VERIFY_USER)
        .then(() => {
          this.redirect();
        })
        .catch(() => {
          this.showForm("request");
        });
    },
    redirect() {
      if (this.$route.query.refer) {
        window.location.href = `${this.$route.query.refer.toString()}/?token=${JwtService.getToken()}`;
      } else {
        this.$router.push({ name: "dashboard" });
      }
    },
    saveAdsToken() {
      if (this.$route.query["utm_source"]) {
        if (this.$route.query["utm_source"] === "takhfifan") {
          this.setCookie("tatoken", this.$route.query["tatoken"], 30);
        }
      }
    }
  }
};
</script>
